/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export const StatisticsManagementRouteMap = {
  CapacityManagement: 'capacity-management',
  UserData: 'user-data',
  UserSubmitAnalysis: 'user-submit-analysis',
  PerformData: 'perform-data',
  JobData: 'job-data',
  RenderData: 'render-data',
  NewUserData: 'new-user-data',
  HardwareData: 'hardware-data',
}

const StatisticsManagement = [
  {
    path: '/capacity',
    name: StatisticsManagementRouteMap.CapacityManagement,
    title: '产能数据',
    redirect: '/data/capacity',
    meta: {
      title: '产能数据',
      active: ['capacity-management'],
      permission: 'node:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/perform',
    name: StatisticsManagementRouteMap.PerformData,
    title: '性能数据',
    redirect: '/data/perform',
    meta: {
      title: '性能数据',
      active: ['perform-data'],
      permission: 'performance:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/user-statistics',
    redirect: '/data/user-data',
    name: StatisticsManagementRouteMap.UserData,
    title: '新用户作业渲染数据',
    meta: {
      title: '新用户作业渲染数据',
      active: ['user-data'],
      permission: 'user:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/user-submit-analysis',
    redirect: '/data/user-submit-analysis',
    name: StatisticsManagementRouteMap.UserSubmitAnalysis,
    title: '新用户提交分析数据',
    meta: {
      title: '新用户提交分析数据',
      active: ['user-submit-analysis'],
      permission: 'user:first:submit:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/job-data',
    name: StatisticsManagementRouteMap.JobData,
    title: '作业数据',
    redirect: '/data/job-data',
    meta: {
      title: '作业数据',
      active: ['job-data'],
      permission: 'task:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/render-data',
    name: StatisticsManagementRouteMap.RenderData,
    title: '渲染数据',
    redirect: '/data/render-data',
    meta: {
      title: '渲染数据',
      active: ['render-data'],
      permission: 'frame:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/new-user-data',
    redirect: '/data/new-user-data',
    name: StatisticsManagementRouteMap.NewUserData,
    title: '用户数据',
    meta: {
      title: '用户数据',
      active: ['new-user-data'],
      permission: 'user:info:stat',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/hardware-data',
    redirect: '/data/hardware-data',
    name: StatisticsManagementRouteMap.HardwareData,
    title: '硬件数据',
    meta: {
      title: '硬件数据',
      active: ['hardware-data'],
      permission: 'hardware:stat',
      showSubiems: false,
    },
    children: [],
  },
]

export default StatisticsManagement
